import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Paper } from 'virtues-bootstrap';
import { map } from 'ramda';

import s from './styles.module.scss';

const items = [
  {
    to: '/profile',
    text: 'header.myProfile',
  },
];

const UserMenu = ({ authLogout, t }) => (
  <Paper>
    {map(
      item => (
        <NavLink key={item.to} className={s.menuBtn} to={item.to}>
          {t(item.text)}
        </NavLink>
      ),
      items,
    )}
    <button className={s.menuBtn} onClick={authLogout} type="button">
      {t('header.logout')}
    </button>
  </Paper>
);

UserMenu.propTypes = {
  t: PropTypes.func.isRequired,
  authLogout: PropTypes.func.isRequired,
};

export default withTranslation()(UserMenu);
